import styled from "styled-components";

export const ErrorLabel = styled.span`
  display: block;
  font-size: 0.75rem;
  color: red;
  padding-top: 0.5rem;
`;
